<template>
  <!-- <div id="app" @contextmenu="handleMouse"> -->
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
	<!-- <div v-if="is_show_link">
		<router-link to="/test1">test1</router-link> |
		<router-link to="/test2">test2</router-link> |
		<router-link to="/helloword">helloword</router-link> | 
		<router-link to="/index">index</router-link> | 
		<router-link to="/list">list</router-link>
	</div> -->
	<router-view></router-view>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'app',
  components: {
    HelloWorld
  },
	data() {
		return {
			is_show_link: true,
		}
	},
	
	created() {
		
	},
	
	mounted() {
		
	},
	
	watch: {
		// 监听路由变化
		$route(to, from) {
			console.log('AppVue监听路由当前：' + to.path, to.fullPath)
			console.log('AppVue监听上一个路由：' + from.path, from.fullPath)
			if (to.path.indexOf('index') > -1) {
				this.is_show_link = false
			} else {
				this.is_show_link = true
			}
			
			if (to.path.indexOf('login') > -1) {
				localStorage.setItem('from_url', from.fullPath);
			}
			
			
		}
	},
	
	methods: {
		// 屏蔽鼠标事件，阻止鼠标事件，——鼠标右键
		// 20240725注释掉下方1行代码，取消原业务中限制鼠标限制鼠标右键功能
		// handleMouse(e) {
		// 	e.preventDefault();
		// },

	}
}
</script>

<style>
</style>
